/**
 * PC 资料中转页：移动端在登录前 replace 到 H5 统一中转。
 * 模型组稳定链接只带 businessType + businessId（可选 url）。
 */

const PASS_THROUGH_QUERY_KEYS = ['businessType', 'businessId', 'url'];

/**
 * 取出可写入 search 的单个 query 值：数组取首个非空项，标量去空白。
 * @param {unknown} value
 * @returns {unknown}
 */
function firstQueryValue(value) {
  let raw = value;
  if (Array.isArray(value)) {
    // 重复 query key 时 Vue Router 给数组，取第一个非空项避免拼成 id1,id2
    raw = value.find((item) => item !== undefined && item !== null && String(item).trim() !== '');
  }
  // 空值原样返回，由调用方决定是否丢弃
  if (raw === undefined || raw === null) return raw;
  // 标量与数组命中项都去空白，避免把空格当成有效 businessId
  return String(raw).trim();
}

/**
 * 是否资料中转路由。
 * @param {{ name?: string, path?: string }} to
 * @returns {boolean}
 */
export function isMaterialRedirectRoute(to) {
  return to?.name === 'materialRedirect' || to?.path === '/material/redirect';
}

/**
 * 手机/平板访问 PC 中转页时，应在触发登录前整页跳到移动端。
 * Electron 客户端即使 UA 像手机也走 PC 路由。
 * @param {{ name?: string, path?: string }} to
 * @param {{ isH5?: boolean, isElectron?: boolean }|null|undefined} [env]
 * @returns {boolean}
 */
export function shouldRedirectMaterialToMobile(to, env) {
  const { isH5 = false, isElectron = false } = env || {};
  return Boolean(isH5 && !isElectron && isMaterialRedirectRoute(to));
}

/**
 * 拼移动端统一中转地址（comein-chat-view `/brm-mobile/material-redirect`）。
 * 不透传 `#c=` 片段定位。
 * @param {{ mobileHost?: string, query?: Record<string, unknown>|null }|null|undefined} [options]
 * @returns {string}
 */
export function buildMobileMaterialRedirectUrl(options) {
  const { mobileHost, query } = options || {};
  const safeQuery = query ?? {};
  const base = String(mobileHost || '').replace(/\/$/, '');
  const params = new URLSearchParams();
  // 只透传模型组稳定链接需要的字段，丢掉 hash 定位等无关参数
  PASS_THROUGH_QUERY_KEYS.forEach((key) => {
    const value = firstQueryValue(safeQuery[key]);
    // 缺参或空白不写入 search，避免带上空 businessId
    if (value === undefined || value === null || value === '') return;
    params.set(key, String(value));
  });
  const search = params.toString();
  return `${base}/brm-mobile/material-redirect${search ? `?${search}` : ''}`;
}
